import TFRPanel from './TFRPanel';
import './TFRPanel.scss';
import tfrPanelSchema from './tfrPanelSchema';

export { TFRPanel, tfrPanelSchema };
